export default __webpack_public_path__ + "static/media/operacionalIcon.853294e0.svg";